import { useEffect, useRef, useState } from 'react';

export const useEllipsisTooltip = (isMultiLine: boolean) => {
  const textElementRef = useRef<HTMLDivElement>(null);
  const [isTooltipEnabled, setIsTooltipEnabled] = useState(false);

  useEffect(() => {
    const resizeObserver = new ResizeObserver(() => {
      const el = textElementRef.current;
      if (!el) return;

      if (isMultiLine) {
        setIsTooltipEnabled(el.scrollHeight > el.clientHeight);
      } else {
        setIsTooltipEnabled(el.scrollWidth > el.clientWidth);
      }
    });

    if (textElementRef.current) {
      resizeObserver.observe(textElementRef.current);
    }

    return () => {
      resizeObserver.disconnect();
    };
  }, [isMultiLine]);

  return { textElementRef, isTooltipEnabled };
};
